import { motion } from "framer-motion";
import { STATS } from "@/data/site";

export const StatsBar = () => {
  return (
    <section data-testid="stats-bar" className="bg-[#C8102E] relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/15 border-x border-white/15">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="px-4 py-8 lg:py-10 text-center"
              data-testid={`stat-${i}`}
            >
              <div className="font-heading text-3xl lg:text-5xl font-bold text-white tracking-tight">{s.value}</div>
              <div className="mt-1 text-[11px] lg:text-xs font-medium uppercase tracking-[0.15em] text-white/80">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
